/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InsurerDto } from '../../models/insurer-dto';

export interface InsurerGetAllForDeclarationProcess$Params {
}

export function insurerGetAllForDeclarationProcess(http: HttpClient, rootUrl: string, params?: InsurerGetAllForDeclarationProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InsurerDto>>> {
  const rb = new RequestBuilder(rootUrl, insurerGetAllForDeclarationProcess.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InsurerDto>>;
    })
  );
}

insurerGetAllForDeclarationProcess.PATH = '/v1/Insurer/GetAllForDeclarationProcess';
